import axios, { AxiosError } from "axios";
import store from "@/store";
import router from "@/router";

const axiosInstance = axios.create({
  baseURL: process.env.NODE_ENV === "production" ? "api/" : "api/",
  withCredentials: true,
  timeout: 2000000,
});

axiosInstance.defaults.timeout = 2000000;

// Interceptor para adjuntar el token a cada solicitud
axiosInstance.interceptors.request.use(
  (config) => {
    try {
      const token = store.getters["auth/token"];
      const isLoggedIn = store.getters["auth/isAuthenticated"];

      // Si el usuario está autenticado y hay token, lo agregamos
      if (isLoggedIn && token) {
        config.headers.Authorization = `Bearer ${token}`;
      }

      // Si el usuario está autenticado pero NO hay token, mostrar alerta
      if (isLoggedIn && !token) {
        console.log("Not Authorization - No token");
        store.dispatch("core/popupDialog", {
          text: "No estás autorizado. Token no disponible.",
          type: "error",
          showCancelButton: false,
        });
      }
    } catch {
      console.log("Error obteniendo el token");
      store.dispatch("core/popupDialog", {
        text: "Error al obtener el token de autenticación.",
        type: "error",
        showCancelButton: false,
      });
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Manejo de errores en las respuestas
function errorResponseHandler(error: AxiosError) {
  // Tipo temporal para data
  const data = error.response?.data as
    | {
      message?: string;
      Message?: string;
      ExceptionMessage?: string;
      detail?: string;
      title?: string;
      response?: { message?: string }
    }
    | undefined;


  const messageAlert =
    data?.message ||
    data?.Message ||
    data?.ExceptionMessage ||      // <= clave para Web API
    data?.detail ||
    data?.title ||
    (typeof data === "string" ? data : undefined) ||
    error.message ||
    "Ocurrió un error desconocido";

  // Mostramos el pop-up
  store.dispatch("core/popupDialog", {
    text: messageAlert,
    type: "error",
    showCancelButton: false,
  });

  // Manejo 401
  if (error.response?.status === 401) {
    console.log("Not Authorization - 401");
    router.push("/login");
    // location.reload();
  }

  // IMPORTANT: rechazamos la promesa para que los catch del front también se activen
  return Promise.reject(error);
}

axiosInstance.interceptors.response.use(
  (res) => res.data,
  (error) => errorResponseHandler(error)
);


export default axiosInstance;
